import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import Sticky from 'react-stickynode';
import Icons from '../elements/icons';

// Images
import logo from "../../images/logo.webp";
import logoWhite from "../../images/logo.webp";
import tikTok from "../../images/icon/tiktok.svg";

const Header = () => {

	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [activeItem, setActiveItem] = useState(null);
	const [isMobileView, setIsMobileView] = useState(false);

	const toggleMenu = () => {
		setIsMenuOpen((prev) => !prev);
	};
	const handleMenuCloseClick = () => {
		setIsMenuOpen(false);
	};
	const toggleSubmenu = (item) => {
		setActiveItem(item === activeItem ? null : item);
	};
	const handleMenuLinkClick = () => {
		if (window.innerWidth <= 991) {
			setIsMenuOpen(false);
		}
	};
	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth >= 768);
		};

		// Check the screen size on initial render and whenever the window is resized
		handleResize();

		window.addEventListener('resize', handleResize);

		// Clean up the event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const menuItems = [
		{
			id: 'home',
			name: 'Početna',
			linkName: '#',
		},
		{
			id: 'about',
			name: 'O nama',
			linkName: 'info',
		},
		{
			id: 'services',
			name: 'Otkup telefona',
			linkName: 'otkup',

			// subItems: [
			// 	{
			// 		id: 'service-1',
			// 		displayName: 'Service 1',
			// 		linkName: 'service-1'
			// 	},
			// 	{
			// 		id: 'service-2',
			// 		displayName: 'Service 2',
			// 		linkName: 'service-2'
			// 	},
			// 	{
			// 		id: 'service-engine-diagnostics',
			// 		displayName: 'Engine Diagnostics',
			// 		linkName: 'service-engine-diagnostics'
			// 	},
			// 	{
			// 		id: 'service-lube-oil-and-filters',
			// 		displayName: 'Lube Oil and Filters',
			// 		linkName: 'service-lube-oil-and-filters'
			// 	},
			// 	{
			// 		id: 'service-belts-and-hoses',
			// 		displayName: 'Belts and Hoses',
			// 		linkName: 'service-belts-and-hoses'
			// 	},
			// 	{
			// 		id: 'service-air-conditioning',
			// 		displayName: 'Air Conditioning',
			// 		linkName: 'service-air-conditioning'
			// 	},
			// 	{
			// 		id: 'service-brake-repair',
			// 		displayName: 'Brake Repair',
			// 		linkName: 'service-brake-repair'
			// 	},
			// 	{
			// 		id: 'service-tire-and-wheel-services',
			// 		displayName: 'Tire and Wheel Services',
			// 		linkName: 'service-tire-and-wheel-services'
			// 	},
			// ]
		},
		{
			id: 'sale',
			name: 'Prodaja',
			linkName: 'prodaja',
		},
		{
			id: 'service',
			name: 'Servis',
			linkName: 'servis',
		},
		{
			id: 'contact',
			name: 'Kontakt',
			linkName: 'kontakt',
		},
	]

	return (
		<>
			<header className="header header-transparent rs-nav">
				<Sticky enabled={true} className="sticky-header navbar-expand-lg active">

					<div className="menu-bar clearfix">
						<div className="container clearfix">
							<div className="menu-logo">
								<Link to="/" className="main-logo">
									<img src={logoWhite} alt="" />
								</Link>
								<Link to="/" className="sticky-logo">
									<img src={logo} alt="" />
								</Link>
							</div>

							<Navbar.Toggle
								className={`navbar-toggler collapsed menuicon justify-content-end ${isMenuOpen ? 'open' : ''}`}
								onClick={toggleMenu}
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#menuDropdown"
								aria-controls="menuDropdown"
								aria-expanded="false"
								aria-label="Toggle navigation"
							>
								<span></span>
								<span></span>
								<span></span>
							</Navbar.Toggle>

							<div className="secondary-menu">
								<a href="tel:+381615796175" rel="noreferrer" className='btn btn-primary tel-anim' target="_blank" >
									<i className="fa fa-phone  pr-10 phone-ring"><Icons name='phone' /></i>
									<strong className='wf-7'>+381615796175</strong> </a>
							</div>

							<Navbar.Collapse
								className={`menu-links navbar-collapse collapse justify-content-center ${isMenuOpen ? 'show' : ''}`}
								id="menuDropdown"
							>
								<div className="menu-logo">
									<Link to="/">
										<img src={logoWhite} alt="" />
									</Link>
								</div>

								<ul className="nav navbar-nav">
									{menuItems.map((item) => (
										<li
											key={item.id}
											className={`${activeItem === item.id ? 'open' : ''}`}
											onClick={() => toggleSubmenu(item.id)}
										>
											{item.subItems ? (
												<Link to="#">
													{item.name}
													<i className={`fa fa-chevron-down`}></i>
												</Link>
											) : (
												<Link to={`/${item.linkName}`} onClick={handleMenuLinkClick}>
													{item.name}
												</Link>
											)}
											{(isMobileView || activeItem === item.id) && item.subItems && (
												<ul className="sub-menu">
													{item.subItems.map((subItem, index) => (
														<li key={subItem.id}><Link to={`${window.location.origin}}${subItem.linkName}`} onClick={handleMenuLinkClick}><span>{subItem.displayName}</span></Link></li>
													))}
												</ul>
											)}
										</li>
									))}
								</ul>

								<ul className="social-media">
									<li><a target="_blank" href="https://www.instagram.com/major.mob" rel="noreferrer" className="btn btn-primary"><i className="fa fa-instagram"><Icons name="insta" /></i></a></li>
									<li><a target="_blank" href="https://www.tiktok.com/@major_mob" rel="noreferrer" className="btn btn-primary"><img alt="tiktok slika" src={tikTok} className="fa-brands fa-tiktok" /></a></li>
								</ul>

								<div className="menu-close" id="menuClose" onClick={handleMenuCloseClick}>
									<i className="ti-close"><Icons name="close" /></i>
								</div>

							</Navbar.Collapse>
						</div>
					</div>
				</Sticky>
			</header>

		</>
	);
}

export default Header;